import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const services = [
    {
      title: 'Ladies & Gents Cuts',
      category: 'Haircuts',
      description: 'Precision cutting tailored to your style, face shape, and lifestyle. From classic to contemporary looks.',
      image: 'https://public.readdy.ai/ai/img_res/bcb4bddad2058a3ea83f05794e9e7e68.jpg',
    },
    {
      title: 'Colour & Styling',
      category: 'Colouring',
      description: 'From subtle highlights to bold transformations. Expert colour matching and application for stunning results.',
      image: 'https://readdy.ai/api/search-image?query=Hair%20colourist%20applying%20professional%20hair%20dye%20with%20brush%20and%20bowl%2C%20colour%20application%20technique%2C%20salon%20colour%20service%2C%20modern%20styling%20station%20with%20mirrors%2C%20soft%20neutral%20background%20tones%2C%20natural%20salon%20lighting&width=800&height=600&seq=service-colour-2025&orientation=landscape',
    },
    {
      title: 'Special Occasions',
      category: 'Styling',
      description: 'Wedding hair, proms, and events. Beautiful updos and styles that last all day and photograph perfectly.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20bridal%20updo%20hairstyle%20being%20created%2C%20sophisticated%20wedding%20hair%20styling%2C%20flowers%20and%20accessories%2C%20romantic%20occasion%20hair%2C%20professional%20stylist%20hands%20working%2C%20soft%20cream%20and%20white%20background%2C%20delicate%20details&width=800&height=600&seq=service-occasions-2025&orientation=landscape',
    },
  ];

  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <div className="inline-block px-4 py-2 bg-blush rounded-full mb-4">
            <span className="text-xs uppercase tracking-wider text-charcoal font-sans font-medium">
              Our Services
            </span>
          </div>
          <h2 className="text-5xl font-bold text-charcoal font-serif mb-4">
            Treatments Tailored to You
          </h2>
          <p className="text-base text-gray-600 font-sans leading-relaxed max-w-3xl">
            At <strong>Riverdale Hair Studio</strong>, we offer a comprehensive range of <strong>hair services in Otley</strong>, combining expert techniques with personalised care. Whether you need a fresh cut, vibrant colour, or styling for a special day, our experienced team delivers exceptional results every time.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#F8F8F6] rounded-[32px] p-6 hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="w-full aspect-[4/3] rounded-3xl overflow-hidden mb-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="inline-block px-4 py-1.5 bg-sage/20 rounded-full mb-3">
                <span className="text-xs uppercase text-charcoal font-sans font-medium tracking-wide">
                  {service.category}
                </span>
              </div>

              <h3 className="text-2xl font-semibold text-charcoal font-serif mb-3">
                {service.title}
              </h3>

              <p className="text-sm text-gray-600 font-sans leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-sage text-sage font-sans text-sm font-medium rounded-full hover:bg-sage hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;